import API from "../../../app/api"; 

export const getCustomers = async () => {
  const response = await API.get("/customers");
  return response.data;
};